// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"styles_spaceBetween__21I5R","fontSize":"styles_fontSize__1nvtQ","SavedOrders":"styles_SavedOrders__2LRN_"};